import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { StatusCodes } from "http-status-codes";
import { Benefit, Enrollment, VEBBenefit, VEBEnrollment } from "../../../@types/enrollment.types";
import { ApproveEnrollment, ApproveHOOEnrollment } from "../../../@types/components/enrollmentProps.types";
const { post, get, put, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member/enrollment";

export type GetBenefitsQuery = {
	group_number: number;
	insured_SSN: string;
	member_SSN?: string;
};

export type GetHistoryEnrollmentsQuery = GetBenefitsQuery;

export type GetVEBHistorybenefitsQuery = GetBenefitsQuery;

export const getNotActiveEnrollments = async (
	query: Record<string, unknown>
): Promise<{ enrollments: Enrollment[]; nonEnrollments: any[] }> => {
	try {
		const endpoint = `${initialRoute}/not-active`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
			throw error;
		} else {
			throw error;
		}
	}
};

export const getNotActiveEnrollmentsByGroup = async (
	group_number: number,
	page?: number,
	limit?: number,
	filters?: Record<string, any>,
	all?: boolean
) => {
	try {
		// const endpoint = `${initialRoute}/not-active/${group_number}`;
		const token = localStorage.getItem("@jwt");

		const params = new URLSearchParams();
		if (!all) {
			if (page) params.append("page", String(page));
			if (limit) params.append("limit", String(limit));
		} else {
			params.append("all", "true"); // tell backend to ignore pagination
		}

		// ✅ Add each filter as its own query param
		if (filters) {
			Object.entries(filters).forEach(([key, value]) => {
				if (value !== null && value !== "") params.append(key, String(value));
			});
		}

		const endpoint = `${initialRoute}/not-active/${group_number}?${params.toString()}`;

		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
			throw error;
		} else {
			throw error;
		}
	}
};

// export const getNotActiveEnrollmentsByGroup = async (
// 	group_number: number,
// 	page?: number,
// 	limit?: number,
// 	filters?: Record<string, any> // optional plain filters
// ) => {
// 	try {
// 		const token = localStorage.getItem("@jwt");

// 		const params = new URLSearchParams();
// 		if (page) params.append("page", String(page));
// 		if (limit) params.append("limit", String(limit));

// 		// ✅ Add each filter as its own query param
// 		if (filters) {
// 			Object.entries(filters).forEach(([key, value]) => {
// 				if (value !== null && value !== "") params.append(key, String(value));
// 			});
// 		}

// 		const endpoint = `${initialRoute}/not-active/${group_number}?${params.toString()}`;

// 		const response = await get(endpoint, {
// 			...headers,
// 			[Authorization]: `${Bearer} ${token}`
// 		});

// 		if (response?.data?.message === MESSAGE.get.succ) {
// 			return response.data.data.result;
// 		}

// 		throw new Error("Unexpected API response");
// 	} catch (error: any) {
// 		if (error.response?.status === StatusCodes.BAD_REQUEST) {
// 			alert(error.response.data?.message);
// 		}
// 		throw error;
// 	}
// };

export type ApproveEnrollmentPayload = ApproveEnrollment & { covered_dependent_SSNs: string[] };

export const approveEnrollment = async (payload: ApproveEnrollmentPayload) => {
	try {
		const endpoint = `${initialRoute}/approve-enrollment`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return {
					status: true,
					result
				};
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export type ApproveWaivedEnrollmentPayload = {
	group_number: number;
	_id: string;
	plan_code: string;
	approval_status: boolean;
	termination_date?: string;
	termination_reason?: string;
};

export const approveWaivedEnrollment = async (payload: ApproveWaivedEnrollmentPayload) => {
	try {
		const endpoint = `${initialRoute}/approve-waived-enrollment`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export type ApproveHOOEnrollmentPayload = ApproveHOOEnrollment;

export const approveHOOEnrollment = async (payload: ApproveHOOEnrollmentPayload): Promise<any> => {
	try {
		const endpoint = `${initialRoute}/approve-HOO-enrollment`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return {
					status: true,
					result
				};
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getBenefits = async (query: GetBenefitsQuery): Promise<Benefit[]> => {
	try {
		const endpoint = `${initialRoute}/benefits`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getVEBBenefits = async (query: GetBenefitsQuery): Promise<VEBBenefit[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/benefits`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export type GETRidersQuery = {
	base_plan_name: string;
} & GetBenefitsQuery;

export const getVEBRidersByPlan = async (query: GETRidersQuery): Promise<VEBEnrollment[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/benefits/riders`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};
export type GetDependentBenefitsQuery = {
	insured_SSN: string;
	member_SSN: string;
	group_number: string;
};

export const getVEBDependentBenefits = async (
	getVEBDependentBenefitsQuery: GetDependentBenefitsQuery
): Promise<VEBEnrollment[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/benefits/dependents`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			getVEBDependentBenefitsQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getDependentBenefits = async (
	getDependentBenefitsQuery: GetDependentBenefitsQuery
): Promise<VEBEnrollment[]> => {
	try {
		const endpoint = `${initialRoute}/benefits/dependents`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			getDependentBenefitsQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getHistoryEnrollments = async (historyEnrollmentsQuery: GetHistoryEnrollmentsQuery) => {
	try {
		const endpoint = `${initialRoute}/nex/benefits/history`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			historyEnrollmentsQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getVEBHistoryBenefits = async (VEBHistoryBenefitsQuery: GetVEBHistorybenefitsQuery) => {
	try {
		const endpoint = `${initialRoute}/veb/benefit/history`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			VEBHistoryBenefitsQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export type TermEnrollmentPayloadType = {
	group_number: number;
	plan_code: string;
	insured_SSN: string;
	termination_reason: string;
	termination_date: string;
};

export const termEnrollment = async (_payload: TermEnrollmentPayloadType, termEnrollmentType: "nex") => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/${termEnrollmentType}/term-enrollment`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export type TermVEBEnrollmentPayloadType = {
	group_number: number;
	base_plan_name: string;
	insured_SSN: string;
	termination_reason: string;
	termination_date: string;
};

export const termVEBEnrollment = async (_payload: TermVEBEnrollmentPayloadType, termEnrollmentType: "VEB") => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/${termEnrollmentType}/term-enrollment`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const approveDynamicEnrollment = async (payload: any) => {
	try {
		const endpoint = `${initialRoute}/approve-dynamic-enrollment`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (response.status === 200) {
				const {
					data: { result }
				} = response;
				return {
					status: true,
					result
				};
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		console.log("response===>", err);
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const enrollment = {
	getNotActiveEnrollments,
	approveEnrollment,
	approveHOOEnrollment,
	getBenefits,
	getNotActiveEnrollmentsByGroup,
	getVEBBenefits,
	getVEBDependentBenefits,
	getVEBRidersByPlan,
	getDependentBenefits,
	getHistoryEnrollments,
	termEnrollment,
	termVEBEnrollment,
	getVEBHistoryBenefits,
	approveDynamicEnrollment
};
